import { render, staticRenderFns } from "./Game_Round_Detail.vue?vue&type=template&id=260099ee&"
import script from "./Game_Round_Detail.vue?vue&type=script&lang=js&"
export * from "./Game_Round_Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports